export interface MovieItem {
  id: string;
  title: string;
  englishTitle: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  duration: string;
  region: string;
  director: string;
  actors: string[];
  description: string;
  tags: string[];
  coverImage: string;
  bannerImage: string;
  isNew: boolean;
  isHot: boolean;
  updateEpisode: string;
  totalEpisodes: number;
}

export const categories = [
  { name: '电影', slug: 'movie', icon: 'ri-movie-2-line' },
  { name: '电视剧', slug: 'tv-series', icon: 'ri-tv-2-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-live-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-ghost-smile-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-film-line' },
  { name: '少儿', slug: 'kids', icon: 'ri-rocket-2-line' },
];

export const heroSlides: MovieItem[] = [
  {
    id: 'hero-1',
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 9.1,
    duration: '148分钟',
    region: '中国大陆',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    description: '太阳急速老化，持续膨胀，百年之内将吞噬整个太阳系。人类面临前所未有之生存危机，为求生存，联合政府决定实施"移山计划"，在地球表面建造一万座行星发动机，推动地球离开太阳系，奔向4.2光年外的新家园。',
    tags: ['科幻', '冒险', '灾难', 'IMAX'],
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20a%20giant%20planet%20earth%20equipped%20with%20massive%20thruster%20engines%20in%20deep%20space%2C%20dramatic%20orange%20and%20blue%20cosmic%20lighting%2C%20epic%20cinematic%20composition%2C%20clean%20professional%20movie%20poster%20style%20with%20Chinese%20title%20space%2C%20no%20text%20visible&width=400&height=560&seq=xgyy-hero-1-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20scene%20of%20earth%20with%20massive%20glowing%20thruster%20engines%20traveling%20through%20deep%20space%20with%20stars%20and%20nebula%2C%20dramatic%20warm%20orange%20and%20cool%20blue%20lighting%20contrast%2C%20cinematic%20widescreen%20composition%2C%20dark%20atmosphere%2C%20professional%20movie%20banner%20quality&width=1600&height=700&seq=xgyy-hero-1-banner&orientation=landscape',
    isNew: false,
    isHot: true,
    updateEpisode: '高清完整版',
    totalEpisodes: 1,
  },
  {
    id: 'hero-2',
    title: '庆余年第二季',
    englishTitle: 'Joy of Life Season 2',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2026,
    rating: 9.3,
    duration: '45分钟/集',
    region: '中国大陆',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    description: '范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣，二人的矛盾就此激发。范闲所面对的抱月楼迷局，以及接踵而至的春闱危机，都是二皇子精心布下的陷阱。',
    tags: ['古装', '权谋', '武侠', '热播'],
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20poster%20with%20a%20handsome%20man%20in%20traditional%20robes%20holding%20a%20sword%2C%20ink%20wash%20painting%20style%20background%20with%20palace%20silhouette%2C%20elegant%20and%20mysterious%20atmosphere%2C%20warm%20golden%20and%20dark%20red%20tones%2C%20professional%20drama%20poster%20quality&width=400&height=560&seq=xgyy-hero-2-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20scene%20with%20dramatic%20lighting%20and%20ink%20wash%20artistic%20style%2C%20elegant%20traditional%20architecture%20with%20warm%20lantern%20light%2C%20mysterious%20court%20atmosphere%2C%20golden%20and%20crimson%20color%20palette%2C%20cinematic%20widescreen%20composition&width=1600&height=700&seq=xgyy-hero-2-banner&orientation=landscape',
    isNew: true,
    isHot: true,
    updateEpisode: '更新至36集/全40集',
    totalEpisodes: 40,
  },
  {
    id: 'hero-3',
    title: '歌手2026',
    englishTitle: 'Singer 2026',
    category: '综艺',
    categorySlug: 'variety',
    year: 2026,
    rating: 8.9,
    duration: '120分钟',
    region: '中国大陆',
    director: '洪涛',
    actors: ['那英', '华晨宇', '周深', '毛不易'],
    description: '顶级音乐竞技综艺，实力唱将同台对决，用音乐传递情感与力量。本季赛制全面升级，加入国际歌手踢馆环节，精彩纷呈不容错过。',
    tags: ['音乐', '竞技', '真人秀', '热播'],
    coverImage: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20with%20vibrant%20stage%20lighting%20and%20a%20microphone%20in%20spotlight%2C%20energy%20and%20passion%20atmosphere%2C%20purple%20and%20golden%20stage%20lights%20with%20audience%20silhouette%2C%20professional%20concert%20poster%20style&width=400&height=560&seq=xgyy-hero-3-cover&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Grand%20music%20concert%20stage%20with%20dazzling%20colorful%20spotlights%20and%20laser%20effects%2C%20massive%20LED%20screen%20background%2C%20energetic%20live%20performance%20atmosphere%2C%20purple%20and%20gold%20lighting%2C%20cinematic%20widescreen%20concert%20photography&width=1600&height=700&seq=xgyy-hero-3-banner&orientation=landscape',
    isNew: true,
    isHot: true,
    updateEpisode: '更新至第8期',
    totalEpisodes: 12,
  },
];

export const hotMovies: MovieItem[] = [
  {
    id: 'hot-1',
    title: '封神第二部',
    englishTitle: 'Creation of the Gods II',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 8.8,
    duration: '156分钟',
    region: '中国大陆',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤'],
    description: '姜子牙携封神榜下昆仑山，寻找天下共主以救苍生。殷寿暴虐无道，天怒人怨，西岐姬发挺身而出，率领八百诸侯起兵伐纣。',
    tags: ['神话', '史诗', '动作', '巨制'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20fantasy%20movie%20poster%20with%20ancient%20warriors%20in%20armor%20riding%20mythical%20beasts%2C%20epic%20battle%20scene%20silhouette%20in%20background%2C%20golden%20and%20crimson%20color%20scheme%2C%20professional%20fantasy%20movie%20poster%20quality&width=400&height=560&seq=xgyy-hot-1&orientation=portrait',
    bannerImage: '',
    isNew: false,
    isHot: true,
    updateEpisode: '高清完整版',
    totalEpisodes: 1,
  },
  {
    id: 'hot-2',
    title: '飞驰人生3',
    englishTitle: 'Pegasus 3',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 8.5,
    duration: '132分钟',
    region: '中国大陆',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正'],
    description: '曾经的赛车冠军张驰再次面临人生的十字路口，这一次他将带领全新的团队征战更加残酷的拉力赛场。速度与激情的碰撞，笑中带泪的人生。',
    tags: ['喜剧', '赛车', '励志'],
    coverImage: 'https://readdy.ai/api/search-image?query=Racing%20car%20movie%20poster%20with%20a%20rally%20car%20drifting%20on%20desert%20road%20kicking%20up%20dust%2C%20warm%20sunset%20lighting%2C%20action%20and%20speed%20atmosphere%2C%20professional%20racing%20movie%20poster%20style&width=400&height=560&seq=xgyy-hot-2&orientation=portrait',
    bannerImage: '',
    isNew: true,
    isHot: true,
    updateEpisode: '高清完整版',
    totalEpisodes: 1,
  },
  {
    id: 'hot-3',
    title: '哪吒之魔童闹海',
    englishTitle: 'Nezha: The Devil Child Rages',
    category: '动漫',
    categorySlug: 'anime',
    year: 2026,
    rating: 9.2,
    duration: '140分钟',
    region: '中国大陆',
    director: '饺子',
    actors: ['吕艳婷', '陈浩', '囧森瑟夫'],
    description: '天劫之后，哪吒和敖丙的灵魂虽然保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给他们重塑肉身，但过程中遇到了重重困难。',
    tags: ['动画', '神话', '喜剧', '3D'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%203D%20animation%20movie%20poster%20featuring%20a%20young%20rebellious%20boy%20with%20flaming%20red%20ribbons%20flying%20in%20the%20air%2C%20mythological%20elements%2C%20vibrant%20red%20and%20gold%20colors%2C%20epic%20fantasy%20atmosphere%2C%20professional%20animation%20movie%20poster&width=400&height=560&seq=xgyy-hot-3&orientation=portrait',
    bannerImage: '',
    isNew: false,
    isHot: true,
    updateEpisode: '高清完整版',
    totalEpisodes: 1,
  },
  {
    id: 'hot-4',
    title: '狂飙',
    englishTitle: 'The Knockout',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2026,
    rating: 9.4,
    duration: '45分钟/集',
    region: '中国大陆',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，清除了政法队伍内部的腐败分子。',
    tags: ['犯罪', '悬疑', '扫黑', '热播'],
    coverImage: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20TV%20drama%20poster%20with%20two%20men%20in%20police%20uniform%20standing%20in%20dark%20alley%20with%20neon%20lights%2C%20tense%20and%20mysterious%20atmosphere%2C%20noir%20style%20with%20blue%20and%20red%20contrast%2C%20professional%20drama%20poster%20quality&width=400&height=560&seq=xgyy-hot-4&orientation=portrait',
    bannerImage: '',
    isNew: false,
    isHot: true,
    updateEpisode: '全39集',
    totalEpisodes: 39,
  },
  {
    id: 'hot-5',
    title: '长津湖之水门桥',
    englishTitle: 'The Battle at Lake Changjin II',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 9.0,
    duration: '149分钟',
    region: '中国大陆',
    director: '徐克',
    actors: ['吴京', '易烊千玺', '朱亚文'],
    description: '电影以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了在结束了新兴里和下碣隅里的战斗之后，七连战士们又接到了更艰巨的任务。',
    tags: ['战争', '历史', '动作'],
    coverImage: 'https://readdy.ai/api/search-image?query=War%20movie%20poster%20with%20soldiers%20in%20winter%20camouflage%20uniforms%20in%20snowy%20mountain%20battlefield%2C%20cold%20blue%20and%20white%20tones%20with%20explosion%20fire%20contrast%2C%20epic%20and%20solemn%20atmosphere%2C%20professional%20war%20movie%20poster&width=400&height=560&seq=xgyy-hot-5&orientation=portrait',
    bannerImage: '',
    isNew: false,
    isHot: true,
    updateEpisode: '高清完整版',
    totalEpisodes: 1,
  },
  {
    id: 'hot-6',
    title: '琅琊榜之风起长林',
    englishTitle: 'Nirvana in Fire 2',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2026,
    rating: 8.7,
    duration: '45分钟/集',
    region: '中国大陆',
    director: '孔笙',
    actors: ['黄晓明', '刘昊然', '佟丽娅'],
    description: '大梁朝局安稳，但边境战火不断。长林军功高盖主，朝堂内外危机四伏。长林王府世子萧平章与弟弟萧平旌共同守卫家国，谱写一曲忠义之歌。',
    tags: ['古装', '权谋', '战争'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20general%20in%20traditional%20armor%20holding%20a%20sword%20in%20the%20rain%2C%20ink%20painting%20style%20with%20mountain%20silhouette%2C%20elegant%20and%20heroic%20atmosphere%2C%20professional%20drama%20poster&width=400&height=560&seq=xgyy-hot-6&orientation=portrait',
    bannerImage: '',
    isNew: true,
    isHot: false,
    updateEpisode: '全50集',
    totalEpisodes: 50,
  },
];

export const latestUpdates: MovieItem[] = [
  {
    id: 'latest-1',
    title: '斗罗大陆2：绝世唐门',
    englishTitle: 'Soul Land 2',
    category: '动漫',
    categorySlug: 'anime',
    year: 2026,
    rating: 8.6,
    duration: '22分钟/集',
    region: '中国大陆',
    director: '沈乐平',
    actors: ['梁达伟', '唐雅菁', '孙晔'],
    description: '霍雨浩自幼母亲被父亲正室残害，在白虎公爵府中受尽欺辱。在测试中，他觉醒了罕见的本体武魂——灵眸，同时也意外发现自己还拥有一个来自远古的武魂。',
    tags: ['玄幻', '热血', '3D动画'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%203D%20animation%20poster%20with%20a%20young%20boy%20in%20martial%20arts%20outfit%20surrounded%20by%20glowing%20spiritual%20energy%2C%20fantasy%20martial%20world%20background%2C%20vibrant%20blue%20and%20gold%20energy%20effects%2C%20professional%20animation%20poster&width=400&height=560&seq=xgyy-latest-1&orientation=portrait',
    bannerImage: '',
    isNew: true,
    isHot: false,
    updateEpisode: '更新至52集',
    totalEpisodes: 78,
  },
  {
    id: 'latest-2',
    title: '奔跑吧第12季',
    englishTitle: 'Keep Running S12',
    category: '综艺',
    categorySlug: 'variety',
    year: 2026,
    rating: 8.2,
    duration: '90分钟',
    region: '中国大陆',
    director: '姚译添',
    actors: ['李晨', '郑恺', '杨颖', '沙溢'],
    description: '新一季奔跑吧重磅回归，经典游戏全新升级，嘉宾阵容更加豪华。每期不同主题挑战，笑料不断，精彩不停。',
    tags: ['真人秀', '户外', '竞技'],
    coverImage: 'https://readdy.ai/api/search-image?query=Variety%20show%20poster%20with%20group%20of%20celebrities%20running%20and%20laughing%20in%20colorful%20sportswear%20on%20sunny%20outdoor%20field%2C%20energetic%20and%20joyful%20atmosphere%2C%20bright%20colorful%20summer%20vibe%2C%20professional%20show%20poster&width=400&height=560&seq=xgyy-latest-2&orientation=portrait',
    bannerImage: '',
    isNew: true,
    isHot: false,
    updateEpisode: '更新至第6期',
    totalEpisodes: 12,
  },
  {
    id: 'latest-3',
    title: '长相思',
    englishTitle: 'Lost You Forever',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2026,
    rating: 9.0,
    duration: '45分钟/集',
    region: '中国大陆',
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为'],
    description: '上古时代，黄帝和蚩尤大战之后，天下初定。流落大荒的高辛王姬玖瑶历经百年颠沛流离，失去了身份和容貌，化身玟小六在清水镇落脚，与神秘的青丘公子涂山璟相遇。',
    tags: ['古装', '爱情', '仙侠'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20beautiful%20woman%20in%20flowing%20ancient%20dress%20in%20a%20cherry%20blossom%20garden%2C%20dreamy%20and%20romantic%20atmosphere%2C%20soft%20pink%20and%20white%20color%20palette%2C%20professional%20drama%20poster&width=400&height=560&seq=xgyy-latest-3&orientation=portrait',
    bannerImage: '',
    isNew: true,
    isHot: true,
    updateEpisode: '更新至28集',
    totalEpisodes: 42,
  },
  {
    id: 'latest-4',
    title: '熊出没·重启未来',
    englishTitle: 'Boonie Bears: Restart the Future',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 8.0,
    duration: '108分钟',
    region: '中国大陆',
    director: '林永长',
    actors: ['张伟', '谭笑', '张秉君'],
    description: '光头强和熊大熊二意外穿越到了未来世界，这里科技高度发达但自然环境却变得陌生。他们必须找到回家的方法，同时拯救这个未来世界。',
    tags: ['动画', '喜剧', '冒险', '合家欢'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20with%20two%20cartoon%20bears%20and%20a%20man%20in%20futuristic%20city%20with%20flying%20cars%2C%20colorful%20and%20playful%20style%2C%20family-friendly%20vibe%2C%20professional%20animation%20poster&width=400&height=560&seq=xgyy-latest-4&orientation=portrait',
    bannerImage: '',
    isNew: true,
    isHot: false,
    updateEpisode: '高清完整版',
    totalEpisodes: 1,
  },
  {
    id: 'latest-5',
    title: '向往的生活第八季',
    englishTitle: 'Back to Field S8',
    category: '综艺',
    categorySlug: 'variety',
    year: 2026,
    rating: 8.4,
    duration: '100分钟',
    region: '中国大陆',
    director: '王征宇',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅'],
    description: '远离城市喧嚣，回归田园生活。蘑菇屋家族再次集结，在美丽的乡村中自给自足，招待远道而来的朋友们，一起体验最纯粹的慢生活。',
    tags: ['慢综艺', '生活', '美食'],
    coverImage: 'https://readdy.ai/api/search-image?query=Slow%20life%20variety%20show%20poster%20with%20people%20cooking%20and%20laughing%20in%20a%20rustic%20countryside%20courtyard%20house%2C%20warm%20sunlight%20and%20green%20plants%2C%20cozy%20and%20peaceful%20rural%20atmosphere%2C%20professional%20show%20poster&width=400&height=560&seq=xgyy-latest-5&orientation=portrait',
    bannerImage: '',
    isNew: true,
    isHot: false,
    updateEpisode: '更新至第4期',
    totalEpisodes: 12,
  },
  {
    id: 'latest-6',
    title: '三体：黑暗森林',
    englishTitle: 'Three-Body: The Dark Forest',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2026,
    rating: 9.5,
    duration: '50分钟/集',
    region: '中国大陆',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾'],
    description: '三体文明的舰队正在向地球驶来，人类只剩下四百年的时间。面对前所未有的危机，人类世界陷入了巨大的恐慌，面壁计划应运而生。',
    tags: ['科幻', '悬疑', '巨制'],
    coverImage: 'https://readdy.ai/api/search-image?query=Sci-fi%20drama%20poster%20with%20dark%20cosmic%20background%20and%20mysterious%20alien%20signal%20waves%20approaching%20earth%2C%20cold%20and%20tense%20atmosphere%2C%20deep%20space%20with%20stars%2C%20professional%20sci-fi%20drama%20poster%20quality&width=400&height=560&seq=xgyy-latest-6&orientation=portrait',
    bannerImage: '',
    isNew: true,
    isHot: true,
    updateEpisode: '更新至16集/全30集',
    totalEpisodes: 30,
  },
];

export const featuredRecommendations: MovieItem[] = [
  {
    id: 'feat-1',
    title: '满江红',
    englishTitle: 'Full River Red',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 8.7,
    duration: '159分钟',
    region: '中国大陆',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译'],
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞，一场惊天阴谋就此展开。',
    tags: ['悬疑', '历史', '喜剧'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20movie%20poster%20set%20in%20ancient%20Chinese%20courtyard%20with%20lanterns%20and%20shadows%2C%20dark%20and%20suspenseful%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20professional%20movie%20poster%20quality&width=400&height=560&seq=xgyy-feat-1&orientation=portrait',
    bannerImage: '',
    isNew: false,
    isHot: true,
    updateEpisode: '高清完整版',
    totalEpisodes: 1,
  },
  {
    id: 'feat-2',
    title: '鬼灭之刃：无限城篇',
    englishTitle: 'Demon Slayer: Infinity Castle',
    category: '动漫',
    categorySlug: 'anime',
    year: 2026,
    rating: 9.3,
    duration: '25分钟/集',
    region: '日本',
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮'],
    description: '无限城决战正式打响，鬼杀队全员坠入鬼舞辻无惨所掌控的无限城中。炭治郎与伙伴们各自为战，面对上弦之鬼的恐怖实力，他们将迎来最惨烈的战斗。',
    tags: ['热血', '战斗', '日漫'],
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20a%20young%20swordsman%20in%20traditional%20outfit%20with%20water%20breathing%20effect%20in%20a%20mysterious%20castle%2C%20dynamic%20action%20pose%2C%20vibrant%20blue%20and%20dark%20atmosphere%2C%20professional%20anime%20poster&width=400&height=560&seq=xgyy-feat-2&orientation=portrait',
    bannerImage: '',
    isNew: true,
    isHot: true,
    updateEpisode: '更新至8集',
    totalEpisodes: 11,
  },
  {
    id: 'feat-3',
    title: '我的阿勒泰',
    englishTitle: 'To the Wonder',
    category: '电视剧',
    categorySlug: 'tv-series',
    year: 2026,
    rating: 9.1,
    duration: '45分钟/集',
    region: '中国大陆',
    director: '滕丛丛',
    actors: ['马伊琍', '周依然', '于适'],
    description: '生长在阿勒泰的汉族少女李文秀，一心在大城市追求文学梦想却屡屡碰壁，被迫回到老家与开小卖部的母亲相依为命。在阿勒泰广袤的草原上，她发现了生命的新可能。',
    tags: ['文艺', '治愈', '生活'],
    coverImage: 'https://readdy.ai/api/search-image?query=Artistic%20drama%20poster%20with%20a%20young%20woman%20standing%20on%20vast%20grassland%20under%20blue%20sky%20with%20white%20clouds%2C%20nostalgic%20and%20peaceful%20atmosphere%2C%20warm%20natural%20lighting%2C%20professional%20drama%20poster%20quality&width=400&height=560&seq=xgyy-feat-3&orientation=portrait',
    bannerImage: '',
    isNew: true,
    isHot: false,
    updateEpisode: '全8集',
    totalEpisodes: 8,
  },
  {
    id: 'feat-4',
    title: '地球脉动第三季',
    englishTitle: 'Planet Earth III',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2026,
    rating: 9.7,
    duration: '60分钟/集',
    region: '英国',
    director: '大卫·爱登堡',
    actors: ['大卫·爱登堡'],
    description: 'BBC史诗级自然纪录片第三季震撼回归，以全新的拍摄技术呈现地球各个角落的壮丽自然景观和野生动物的生存故事，画面之精美令人叹为观止。',
    tags: ['自然', '动物', 'BBC'],
    coverImage: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20a%20majestic%20mountain%20landscape%20and%20wild%20animals%20in%20their%20natural%20habitat%2C%20breathtaking%20scenery%20with%20golden%20sunset%20light%2C%20professional%20BBC%20documentary%20poster%20quality&width=400&height=560&seq=xgyy-feat-4&orientation=portrait',
    bannerImage: '',
    isNew: false,
    isHot: true,
    updateEpisode: '全8集',
    totalEpisodes: 8,
  },
];

export const categoryContentMap: Record<string, MovieItem[]> = {
  movie: [...hotMovies.filter((m) => m.categorySlug === 'movie'), ...latestUpdates.filter((m) => m.categorySlug === 'movie'), ...featuredRecommendations.filter((m) => m.categorySlug === 'movie')],
  'tv-series': [...hotMovies.filter((m) => m.categorySlug === 'tv-series'), ...latestUpdates.filter((m) => m.categorySlug === 'tv-series'), ...featuredRecommendations.filter((m) => m.categorySlug === 'tv-series')],
  variety: [...hotMovies.filter((m) => m.categorySlug === 'variety'), ...latestUpdates.filter((m) => m.categorySlug === 'variety'), ...featuredRecommendations.filter((m) => m.categorySlug === 'variety')],
  anime: [...hotMovies.filter((m) => m.categorySlug === 'anime'), ...latestUpdates.filter((m) => m.categorySlug === 'anime'), ...featuredRecommendations.filter((m) => m.categorySlug === 'anime')],
  documentary: featuredRecommendations.filter((m) => m.categorySlug === 'documentary'),
  kids: [],
};

export const allMovies: MovieItem[] = [
  ...heroSlides,
  ...hotMovies,
  ...latestUpdates,
  ...featuredRecommendations,
];